import { Component, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MenuPage } from '../menu/menu.page';
import { AppComponent } from '../../app.component';
import { TranslateService } from '@ngx-translate/core';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { NavigationService, NAVIGATIONURLS } from 'src/app/services/navigation.service';
import { InfoModalComponent } from 'src/app/components/info-modal/info-modal.component';
import { Location } from '@angular/common';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { WelcomeLoginSsoModalComponent } from 'src/app/components/welcome-login-sso-modal/welcome-login-sso-modal.component';

@Component({
	selector: 'app-order',
	templateUrl: './order.page.html',
	styleUrls: ['order.page.scss'],
})
export class OrderPage extends RepositoryDirective implements OnInit {
	static url = 'order';
	public order: Order;
	public venue: Venue;
	static failUrlWithPaymentParam = 'payment/fail/:payment';
	static cancelUrlWithPaymentParam = 'payment/cancel/:payment';
	static paymentFailUrl = 'payment/fail';
	static paymentCancelUrl = 'payment/cancel';
	loading = false;
	@Input() name!: string;

	private readonly location = inject(Location);

	constructor(
		protected repository: RepositoryService,
		private translate: TranslateService,
		private snackbarCtrl: MatSnackBar,
		private navigationService: NavigationService,
		private router: Router,
		private modalCtrl: ModalController
	) {
		super(repository);
	}

	get title(): string {
		return this.translate.instant('menu_page.basket_title');
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.order = JSON.parse(localStorage.getItem('order')) as Order;
		// this.venue = JSON.parse(localStorage.getItem('venue')) as Venue;
		switch (window.location.pathname) {
			case '/' + NAVIGATIONURLS.order():
				break;
			case '/' + NAVIGATIONURLS.paymentCancel:
				console.log(this.translate.instant('order.payment_cancel'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_cancel'), null, {
					duration: 2000,
				});
				break;
			case '/' + NAVIGATIONURLS.paymentFail:
				console.log(this.translate.instant('order.payment_fail'));
				this.snackbarCtrl.open(this.translate.instant('order.payment_fail'), null, {
					duration: 5000,
				});
				break;
		}
		console.log(this.router.url);
		if (this.router.url.includes('/payment/fail')) {
			this.name = localStorage.getItem('storeName') || '';

			if (this.name) {
				const urlTree = this.router.parseUrl(this.router.url);
				urlTree.queryParams['name'] = this.name;
			}

			InfoModalComponent.show(this.modalCtrl, {
				name: this.name,
				title: this.translate.instant('order.payment_fail'),
				info: '',
				mainButton: this.translate.instant('order.btn_try_again'),
				closeButton: this.translate.instant('order.btn_choose_another'),
			});
		}
	}

	// async backClick() {
	// 	await this.navigationService.menu();
	// }
	goBack() {
		this.location.back();
	}
}
